import { useEffect, useState } from "react";
import { Redirect, useParams } from "react-router-dom";
import { Box, Button, Checkbox, CircularProgress, CssBaseline, FormControl, FormControlLabel, FormGroup, Grid, Radio, RadioGroup, TextField, Typography } from "@mui/material";
import MetaDecorator from "../../services/meta_decorator";
import NDReferralHeader from "../../components/shared/ndreferralheader";
import { getApiUrl } from "../../services/api_service";
import MakeReferral from "./makereferral";
import Footer from "../../components/shared/footer";
import { bodyBg, footerContainer, fullHeight, orangecolor, pcolor, rcolor, whitecolor } from "../../style2";

export default function ScreenProcess(props) {
    const { orgCode } = useParams();
    const [loading, setLoading] = useState('');
    const [error, setError] = useState('');
    const [redirect, setRedirect] = useState('');
    const [isLoggedIn, setLoggedIn] = useState(false);
    const [form, setForm] = useState(null);
    const [page, setPage] = useState(1);
    const [abort, setAbort] = useState(false);
    const [abortDisplay, setAbortDisplay] = useState(null);
    const [showPatientReferralForm, setShowPatientReferralForm] = useState(false);

    useEffect(() => {
        const authTokens = localStorage.getItem("authTokens");
        let token;

        if (authTokens) {
            const parsedAuthTokens = JSON.parse(authTokens);
            token = parsedAuthTokens?.accessToken;
        }
        if (!token) {
            setRedirect(`/referral/login/${orgCode}`);
            return;
        }
        setLoading(true);
        fetch(`${getApiUrl()}/ReferralApp/screeningquestions?code=${orgCode}`, {
            method: "get",
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`
            },

        }).then(resp => {
            if (resp.status === 200) {
                resp.json().then(data => {
                    setForm(data);
                    setLoggedIn(true);
                });
            } else if (resp.status === 401 || resp.status === 403) {
                setRedirect(`/referral/login/${orgCode}`);
                setLoggedIn(false);
            } else {
                resp.json().then(data => {
                    setError(data.error);
                    console.log(data);
                }).catch(err2 => {
                    console.log(err2);
                    setError("Unable to load screen questions.");
                });
            }
        }).catch(err => {
            setError('Unable to contact server. Check your internet connection.');
            console.log(err);
        }).finally(() => { setLoading(false); });
    }, [orgCode])

    const runRules = () => {
        console.log(form);
        const authTokens = localStorage.getItem("authTokens");
        let token;

        if (authTokens) {
            const parsedAuthTokens = JSON.parse(authTokens);
            token = parsedAuthTokens?.accessToken;
        }
        if (!token) {
            setRedirect(`/referral/login/${orgCode}`);
            return;
        }
        setError('');
        setLoading(true);
        fetch(`${getApiUrl()}/ReferralApp/applyrules?code=${orgCode}`, {
            method: "POST",
            body: JSON.stringify(form),
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`
            },

        }).then(resp => {
            if (resp.status === 200) {
                resp.json().then(data => {
                    if (data.abort) {
                        setAbort(data.abort);
                        setAbortDisplay(data.displayData);

                    } else {
                        if (page < form.pages.length)
                            setPage(page + 1);
                        else
                            setShowPatientReferralForm(true);
                    }
                });
            } else if (resp.status === 401 || resp.status === 403) {
                setRedirect(`/referral/login/${orgCode}`);
                setLoggedIn(false);
            } else {
                resp.json().then(data => {
                    setError(data.error);
                    console.log(data);
                }).catch(err2 => {
                    console.log(err2);
                    setError("Unable to apply rules.");
                });
            }
        }).catch(err => {
            setError('Unable to contact server. Check your internet connection.');
            console.log(err);
        }).finally(() => { setLoading(false); });
    }

    /*Call this function only when some question has EvaluateOnAnswer true*/
    const onAnswered = () => {
        const authTokens = localStorage.getItem("authTokens");
        let token;

        if (authTokens) {
            const parsedAuthTokens = JSON.parse(authTokens);
            token = parsedAuthTokens?.accessToken;
        }
        if (!token) {
            setRedirect(`/referral/login/${orgCode}`);
            return;
        }
        setError('');
        setLoading(true);
        fetch(`${getApiUrl()}/ReferralApp/evaluateanswer?code=${orgCode}`, {
            method: "POST",
            body: JSON.stringify(form),
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`
            },

        }).then(resp => {
            if (resp.status === 200) {
                resp.json().then(data => {
                    setForm(data);
                });
            } else if (resp.status === 401 || resp.status === 403) {
                setRedirect(`/referral/login/${orgCode}`);
                setLoggedIn(false);
            } else {
                resp.json().then(data => {
                    setError(data.error);
                    console.log(data);
                }).catch(err2 => {
                    console.log(err2);
                    setError("Unable to apply rules.");
                });
            }
        }).catch(err => {
            setError('Unable to contact server. Check your internet connection.');
            console.log(err);
        }).finally(() => { setLoading(false); });
    }

    const validatePage = () => {
        let p = form.pages[page - 1];
        if (p !== null) {
            for (let k in p.questions) {
                let q = p.questions[k];
                if (q.hidden)
                    continue;
                if (q.isRequired) {
                    if ((q.answerType === 1 || q.answerType === 8 || q.answerType === 7) && (q.answer === null || q.answer === "")) {
                        setError("Please answer all questions on this page.");
                        return false;
                    }

                    if (q.answerType === 4 && (q.options !== null && q.options.filter(t => t.selected).length === 0)) {
                        setError("Please answer all questions on this page.");
                        return false;
                    }
                }
            }
        }

        return true;
    }

    if (redirect !== "")
        return <Redirect to={redirect} />
    else
        return <Box sx={{ ...bodyBg, ...fullHeight }}>
            <CssBaseline />
            <MetaDecorator title={"EnrichMyCare - Make A Referral"} description={"EnrichMycare Make Refferal"} />
            <NDReferralHeader date={Date.UTC()} orgCode={orgCode} isLoggedIn={isLoggedIn} logo="../../Logo_Option_1.svg" />
            <Box sx={{ padding: 5, margin: "0 auto", minHeight: "80vh" }}>
                {error !== "" ? <Box mt={1} mb={2} sx={{ color: rcolor, fontSize: "1.1rem", textAlign: "center" }}>{error}</Box> : null}
                {loading ? <CircularProgress size={20} /> : null}
                {form !== null && !abort ? <>
                    {!showPatientReferralForm && form.pages.map((item, index) => {
                        if (item.sequence === page) {
                            return <>
                                <Box sx={{ background: whitecolor, borderRadius: 1, padding: "5px", marginBottom: "5px" }}>
                                    <Grid container fullWidth>
                                        <Grid item md={10}>
                                            <Box padding={1}>
                                                <Typography style={{ color: rcolor, fontSize: "1.8rem", fontWeight: 'bold' }}>{item.title}</Typography>
                                            </Box>
                                        </Grid>
                                        <Grid item></Grid>
                                    </Grid>
                                </Box>
                                <Box sx={{ background: whitecolor, borderRadius: 1 }} padding={2} paddingLeft={3} paddingRight={3}>
                                    <Typography style={{ fontSize: "1.4rem", color: pcolor }}>{item.description}</Typography>
                                    <Box mb={3}></Box>
                                    <form onSubmit={(e) => {
                                        e.preventDefault();
                                        if (validatePage()) {
                                            runRules();
                                        }
                                    }}>
                                        {item.questions.map((q, index) => {
                                            if (q.hidden)
                                                return null;
                                            return <Box key={q.id} mb={3}>
                                                {q.answerType === 1 ? <>
                                                    <Typography style={{ fontSize: "1.2rem", color: pcolor }}>{q.text}</Typography>
                                                    <Box mb={2}></Box>
                                                    <TextField style={{ border: `1px solid ${pcolor}`, borderRadius: 5, width: "50%" }} inputProps={{ type: 'date' }}
                                                        required={q.isRequired} variant="outlined" defaultValue={q.answer} onChange={(event) => {
                                                            q.answer = event.target.value;
                                                            //setForm(form);
                                                            if (q.evaluateOnAnswer) {
                                                                onAnswered();
                                                            }
                                                        }} />
                                                </> : null}
                                                {q.answerType === 8 ? <FormControlLabel required={q.isRequired} control={<Checkbox defaultChecked={q.answer === "1"}
                                                    onChange={(event) => {
                                                        q.answer = event.target.checked ? "1" : "0";
                                                        setForm(form);
                                                        if (q.evaluateOnAnswer) {
                                                            onAnswered();
                                                        }
                                                    }} />} label={q.text} style={{ fontSize: "1.4rem", color: pcolor}} /> : null}
                                                {q.answerType === 7 ? <>
                                                    <Typography style={{ fontSize: "1.2rem", color: pcolor}}>{q.text}</Typography>
                                                    <Box mb={2}></Box>
                                                    <FormControl>
                                                        <RadioGroup row
                                                            name={q.id}
                                                            defaultValue={q.answer}
                                                            onChange={(event) => {
                                                                q.answer = event.target.value;
                                                                setForm(form);
                                                                if (q.evaluateOnAnswer) {
                                                                    onAnswered();
                                                                }
                                                            }}
                                                        >
                                                            <FormControlLabel value="yes" control={<Radio />} label="Yes" />
                                                            <FormControlLabel value="no" control={<Radio />} label="No" />
                                                        </RadioGroup>
                                                    </FormControl>
                                                </> : null}
                                                {q.answerType === 4 ? <>
                                                    <Typography style={{ fontSize: "1.2rem", color: pcolor}}>{q.text}</Typography>
                                                    <Box mb={2}></Box>
                                                    {q.isMultipleChoice ? <FormGroup>
                                                        {q.options !== null && q.options.map((o) => {
                                                            return <FormControlLabel key={o.id} control={<Checkbox defaultChecked={o.selected} onChange={(event) => {
                                                                o.selected = event.target.checked;
                                                                setForm(form);
                                                                if (q.evaluateOnAnswer) {
                                                                    onAnswered();
                                                                }
                                                            }} />} label={o.display} />
                                                        })}
                                                    </FormGroup> : <FormControl>
                                                        <RadioGroup row={q.orientation === "horizontal"}
                                                            name={q.id}
                                                            defaultValue={q.options.filter(t => t.selected).length > 0 ? q.options.filter(t => t.selected)[0].id : ""}
                                                            onChange={(event) => {
                                                                q.options.map(item => {
                                                                    if (event.target.value === item.id)
                                                                        item.selected = true;
                                                                    else
                                                                        item.selected = false;
                                                                })
                                                                setForm(form);
                                                                if (q.evaluateOnAnswer) {
                                                                    onAnswered();
                                                                }
                                                            }}
                                                        >
                                                            {q.options !== null && q.options.map((o) => {
                                                                return <FormControlLabel value={o.id} control={<Radio value={o.id} />} label={o.display} sx={{ fontSize: "1.2rem" }} />
                                                            })}
                                                        </RadioGroup>
                                                    </FormControl>}
                                                </> : null}
                                            </Box>;
                                        })}
                                        <Grid container fullWidth>
                                            <Grid item xs={4}>
                                                {page > 1 ? <Button type="button" variant="contained" disabled={loading || page === 1} onClick={() => { setPage(page - 1) }}>Previous</Button> : null}

                                            </Grid>
                                            <Grid item xs={4}>
                                                <Button type="submit" variant="contained" disabled={loading}>Next</Button>
                                            </Grid>
                                        </Grid>
                                        {error !== "" ? <Box mt={2} mb={2} sx={{ color: rcolor, fontSize: "1.1rem" }}>{error}</Box> : null}
                                    </form>
                                </Box>
                            </>;
                        }
                    })}
                    {showPatientReferralForm ? <MakeReferral form={form} orgCode={orgCode} /> : null}
                </> : null}
                {abort ? <>
                    {abortDisplay !== null ? <Box sx={{ background: whitecolor, borderRadius: 1, padding: 2, marginBottom: "5px" }}>
                        <Box sx={{ textAlign: "left", mb: 1 }}>
                            <Typography style={{ color: rcolor, fontSize: "1.8rem", fontWeight: 'bold' }}>{abortDisplay.title}</Typography>
                        </Box>
                        <Box dangerouslySetInnerHTML={{ __html: abortDisplay.message }} sx={{ fontSize: "1.2rem", padding: 1, textAlign: "left", mb: 3 }}></Box>
                        <Box sx={{ textAlign: "right", p: 2 }}>
                            <Button style={{ background: orangecolor, color: whitecolor, minWidth: "100px" }} onClick={() => { setRedirect(`/referral/whoareyou/${orgCode}`) }}>Ok</Button>
                        </Box>
                    </Box> : <Box sx={{ background: whitecolor, borderRadius: 5, padding: 15, marginBottom: "5px" }}>
                        <Typography style={{ color: rcolor, fontSize: "1.8rem", fontWeight: 'bold' }}>You cannot proceed for the referral</Typography>
                        <Box sx={{ textAlign: "center", p: 2 }}>
                            <Button style={{ background: orangecolor, color: whitecolor, minWidth: "100px" }} onClick={() => { setRedirect(`/referral/whoareyou/${orgCode}`) }}>Ok</Button>
                        </Box>
                    </Box>}
                </> : null}
            </Box>
            <Box sx={{...footerContainer, position:"static"}}>
                <Footer />
            </Box>
        </Box>;
}